import { formatDateTime } from '../format';
import {
  normalizeDocumentLocale,
  printLabelsFor,
  type DocumentLocaleCode,
} from '../printLabels';

/** 출력물 머리말 정보 — 각 문서가 자신의 평탄 필드(orderNo/orderedAt)로 구성한다. */
export interface DocumentHeaderInfo {
  shopName: string;
  orderNo: string;
  /** ISO datetime. 발행/주문 일시. */
  issuedAt: string | null;
}

interface DocumentHeaderProps {
  title: string;
  header: DocumentHeaderInfo;
  /**
   * [글로벌몰] 주문 발생 몰 locale — 라벨/날짜를 이 locale 로 그린다(관리자 UI 언어 아님).
   * 문자열(BE localeCode/ISO 코드)도 받아 정규화한다.
   */
  localeCode: DocumentLocaleCode | string | null | undefined;
}

/** 출력물 공통 머리말 — 문서명·쇼핑몰·주문번호·발행일시. */
export const DocumentHeader = ({ title, header, localeCode }: DocumentHeaderProps) => {
  const locale = normalizeDocumentLocale(localeCode);
  const labels = printLabelsFor(locale);
  return (
    <header style={{ marginBottom: 16 }}>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 700,
          textAlign: 'center',
          letterSpacing: '0.3em',
          marginBottom: 12,
        }}
      >
        {title}
      </h1>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 12,
          paddingBottom: 8,
          borderBottom: '2px solid #111',
        }}
      >
        <span style={{ fontWeight: 600 }}>{header.shopName}</span>
        <span>
          {labels.field.orderNo}: {header.orderNo}
          {' · '}
          {labels.field.issuedAt}: {formatDateTime(header.issuedAt)}
        </span>
      </div>
    </header>
  );
};
